import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'

const MANAGED_QUERY_PARAMS = ['modalId', 'registro', 'isbn', 'idVetor', 'tipo']
const openDialogs = []

export const resetIdentifiedDialogStackForTests = () => {
  openDialogs.splice(0, openDialogs.length)
}

export const buildIdentifiedDialogUrl = (href, dialog) => {
  const url = new URL(href)
  const managedParams = MANAGED_QUERY_PARAMS.reduce((result, param) => {
    result[param] = true
    return result
  }, {})
  const queryParts = (url.search || '')
    .replace(/^\?/, '')
    .split('&')
    .filter(Boolean)
    .filter(part => {
      const encodedName = part.split('=')[0]
      let name = encodedName

      try {
        name = decodeURIComponent(encodedName)
      } catch (e) {
        // Mantém parâmetros inválidos que não pertencem ao controle de modais.
      }

      return !managedParams[name]
    })

  if (dialog && dialog.modalId) {
    queryParts.push('modalId=' + encodeURIComponent(dialog.modalId))

    Object.keys(dialog.params || {}).forEach(param => {
      if (!MANAGED_QUERY_PARAMS.includes(param) || param === 'modalId') return

      const value = dialog.params[param]
      if (value !== undefined && value !== null && String(value).trim()) {
        queryParts.push(encodeURIComponent(param) + '=' + encodeURIComponent(value))
      }
    })
  }

  return url.pathname + (queryParts.length ? '?' + queryParts.join('&') : '') + url.hash
}

const syncBrowserUrl = () => {
  if (typeof window === 'undefined' || !window.history || !window.location) return

  const currentDialog = openDialogs.length ? openDialogs[openDialogs.length - 1] : null
  const nextUrl = buildIdentifiedDialogUrl(window.location.href, currentDialog)
  window.history.replaceState(window.history.state, '', nextUrl)
}

export class IdentifiedDialog extends Component {
  dialogToken = {}

  componentDidMount() {
    if (this.props.open) this.activate()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.activate()
    } else if (prevProps.open && !this.props.open) {
      this.deactivate()
    } else if (this.props.open) {
      this.updateRegistration()
    }
  }

  componentWillUnmount() {
    this.deactivate()
  }

  getRegistration = () => ({
    token: this.dialogToken,
    modalId: this.props.modalId,
    params: this.props.modalParams || {},
  })

  activate = () => {
    const existingIndex = openDialogs.findIndex(dialog => dialog.token === this.dialogToken)
    if (existingIndex !== -1) openDialogs.splice(existingIndex, 1)
    openDialogs.push(this.getRegistration())
    syncBrowserUrl()
  }

  updateRegistration = () => {
    const existingIndex = openDialogs.findIndex(dialog => dialog.token === this.dialogToken)
    if (existingIndex === -1) {
      this.activate()
      return
    }

    openDialogs[existingIndex] = this.getRegistration()
    if (existingIndex === openDialogs.length - 1) syncBrowserUrl()
  }

  deactivate = () => {
    const existingIndex = openDialogs.findIndex(dialog => dialog.token === this.dialogToken)
    if (existingIndex === -1) return

    openDialogs.splice(existingIndex, 1)
    syncBrowserUrl()
  }

  render() {
    const { modalId, modalParams, ...dialogProps } = this.props

    return (
      <Dialog
        {...dialogProps}
        id={modalId}
        aria-labelledby={modalId + '-title'}
      />
    )
  }
}

IdentifiedDialog.propTypes = {
  modalId: PropTypes.string.isRequired,
  modalParams: PropTypes.object,
  open: PropTypes.bool,
}

export default IdentifiedDialog



// WEBPACK FOOTER //
// ./src/components/IdentifiedDialog.js